import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  OWNER_AD_SPEND_ACCURACY_WARNING,
  OWNER_AD_SPEND_ACCURACY_WARNING_ESTIMATED,
} from "../../../../i18n/keysTranslations";
import { BORDER_RADIUS } from "../../../../utils/constants";
import { formatAdSpendUsd } from "./adSpendDisplay";

const ALERT_SX = {
  borderRadius: BORDER_RADIUS,
  width: "100%",
  color: "#78350F",
  backgroundColor: "#FFFBEB",
  borderColor: "#F59E0B",
  "& .MuiAlert-icon": { color: "#B45309" },
  "& .MuiTypography-root": { color: "inherit" },
};

const AdSpendAccuracyWarning = ({ estimatedSpendUSD = 0 }) => {
  const { t, i18n } = useTranslationApp();
  const language = i18n.language;
  const showEstimated = estimatedSpendUSD > 0;

  return (
    <Alert severity="warning" variant="outlined" sx={ALERT_SX}>
      <Typography variant="body2">
        {t(OWNER_AD_SPEND_ACCURACY_WARNING)}
      </Typography>
      {showEstimated ? (
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {t(OWNER_AD_SPEND_ACCURACY_WARNING_ESTIMATED, {
            value: formatAdSpendUsd({ value: estimatedSpendUSD, language }),
          })}
        </Typography>
      ) : null}
    </Alert>
  );
};

export default AdSpendAccuracyWarning;
